import { mathPlugin } from '@benrbray/prosemirror-math';
import { mathSerializer } from '@benrbray/prosemirror-math';
import { Plugin } from 'prosemirror-state';

import { EditorOptions } from '@lyearn/lygo-core';

function plugins(_editorOptions: EditorOptions): Plugin[] {
  return [
    mathPlugin,
    new Plugin({
      props: {
        clipboardTextSerializer: (slice) => {
          return mathSerializer.serializeSlice(slice);
        },
      },
    }),
  ];
}

export default plugins;
